<template>
  <div class="animated fadeIn">
  <b-row>
    <b-col cols="12" lg="12">
      <b-card class="w-100" no-header>
        <template slot="header">
          <span class="mt-2">Endorsement : {{ details.code }} {{ details.title }}</span>
          <b-button @click="goBack" class="btn-sm pull-right">Back</b-button>
        </template>


        <div id="error" class="card border-danger" v-show="error">
          <div class="card-header bg-danger border-danger">

              <span class="text-white font-weight-bolder">
              <i class="fa fa-exclamation-triangle"></i>
               &nbsp;
              {{ error_heading }}
              </span>

          </div>
          <div class="card-body border-danger text-dark font-weight-bold">

            {{ error_text }}

          </div>
        </div>

        <div>

          <b-form-row class="mb-3">

            <b-col cols="2">
              <label class="">Code</label>
              <b-input v-model="$v.details.code.$model" class="mb-2 mr-sm-2 mb-sm-0" :state="validateState('code')"></b-input>
              <b-form-invalid-feedback v-if="!$v.details.code.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

            <b-col cols="10">
              <label class="">Title</label>
              <b-input v-model="$v.details.title.$model" class="mb-2 mr-sm-2 mb-sm-0"  :state="validateState('title')"></b-input>
              <b-form-invalid-feedback v-if="!$v.details.title.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

          </b-form-row>

          <b-form-row class="mb-3">

            <b-col cols="6">
              <label class="">Type</label>
              <b-form-select v-model="$v.details.type.$model" :options="options.types" :state="validateState('type')"></b-form-select>
              <b-form-invalid-feedback v-if="!$v.details.type.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

            <b-col cols="6">
              <label class="">Insurer</label>
              <b-form-select v-model="$v.details.insurer.$model" :options="options.insurers" :state="validateState('insurer')"></b-form-select>
              <b-form-invalid-feedback v-if="!$v.details.insurer.required">This is a required field.</b-form-invalid-feedback>
            </b-col>

          </b-form-row>

          <b-form-row class="mb-3">

            <b-col cols="12">
              <label class="">Endorsement Text</label>
              <editor v-model="details.text" :options="editorOption" :toolbar="toolbarOptions"></editor>
            </b-col>
          </b-form-row>

        </div>

        <template slot="footer">
          <b-button @click="goBack" class="float-left">Back</b-button>
          <b-button variant="success" @click="editEndorsement" class="float-right">Edit Endorsement</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>

  </div>

</template>

<script>
  import axios from '../../../shared/axios/auth-no-loader'
  import Id from "bootstrap-vue/src/mixins/id";
  import { validationMixin } from 'vuelidate'
  import { required } from "vuelidate/lib/validators";
  import VueQuillEditor from 'vue-quill-editor'

  // require styles
  import 'quill/dist/quill.snow.css'

  var toolbarOptions = [
    ["bold","italic","underline",],
    [{list:"ordered"},{list:"bullet"}],
    [{header:1},{header:2},{header:3}],
    [{header:[1,2,3,4,5,6,!1]}]
  ]

  export default {
    name: 'EndorsementEdit',
    components: {
      Id,
      editor: VueQuillEditor.quillEditor
    },
    mixin: [validationMixin],
    props: {
      caption: {
        type: String,
        default: 'Edit'
      },
    },
    data: () => {
      return {
        details: {
          id: "",
          code: "",
          title: "",
          text: "",
          insurer: "",
          type: ""
        },
        toolbarOptions: toolbarOptions,
        editorOption: {
          theme: 'snow',
          modules: {
            toolbar: toolbarOptions
          },
        },
        error: false,
        error_heading: '',
        error_text: '',
        server_errors: {
          code: null,
          title: null,
          text: null,
          insurer: null
        },
        options: {
          insurers: [],
          types: []
        }
      }
    },
    validations() {

      return {
        details: {
          code: {
            required
          },
          title: {
            required
          },
          text: {
            required
          },
          insurer: {

          },
          type: {
            required
          }
        }
      }

    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      validateState(name) {

        if (this.$v.details[name]) {
          const {$dirty, $error} = this.$v.details[name];
          return $dirty ? !$error : null;
        }
      },
      resetServerError(name) {

        if (this.server_errors[name]) {
          this.server_errors[name] = null;
        }

      },
      getEndorsement() {
        let url = '';

        url = '/endorsements/' + this.$route.params.id + '/?product=' + this.$route.params.product

        axios.get(url).then(
          response => {
            this.details = response.data;
            this.options.insurers = response.data.insurers;
            this.options.types = response.data.types;
          }
        ).catch(error => {

            // Unauthorised
            if (error.response.status === 401) {
              this.$store.dispatch('logout');
            }

            console.log('premium error');
            console.log(error.response)
          })
      },
      editEndorsement() {

        this.error = false;

        this.$v.$touch();

        if(this.$v.$anyError) {

          window.scrollTo(document.querySelector('#error').offsetTop, 100);
          this.error = true;
          this.error_heading = 'There are errors on the form';
          this.error_text = 'Please fix the errors and re-submit the form';
          return

        } else {

          const post_data = JSON.parse(JSON.stringify(this.details));

          let url = '';

          url = '/endorsements/' + this.$route.params.id + '/?product=' + this.$route.params.product;

          axios.put(url, post_data).then(
            response => (
              this.data = response.data
            )
          ).then(response => {
            response

            let alert = {
              type: 'success',
              text: 'Endorsment : ' + this.details.code + ' ' + this.details.title + ' was updated successfully!'
            };

            this.$store.commit(
              'setGlobalAlert',
              alert
            )
            this.$router.replace({name: 'Endorsements'})

        }).catch(error => {

            // Unauthorised
            if (error.response.status === 401) {
              this.$store.dispatch('logout');
            }

            if (error.response.status === 400) {

              window.scrollTo(document.querySelector('#error').offsetTop, 100);
              this.error = true;
              this.error_heading = 'There are errors on the form';
              this.error_text = 'Please fix the errors and re-submit the form';

              if (error.response.data) {

                //this.server_errors = error.response.data

                for (var key in error.response.data){

                  this.server_errors[key] = error.response.data[key][0]
                }
                this.$v.$reset();
                this.$v.$touch();

              }

            }

            console.log('premium error');
            console.log(error.response)
          });

        }
      }
    },
    mounted() {
      this.getEndorsement()
      this.$v.details.$reset();
      this.$v.$reset()
    }
  }
</script>

<style>

  #data .card-header {
    padding-top: 1.5rem;
  }
</style>
